<template>
  <b-card>
    <b-row class="table-filter">
      <b-col cols="2">
        <b-form-group
          id="input-from-date"
          label="Từ Ngày"
          label-for="from-date"
        >
          <datePicker v-model="filter_from" :config="dpOptions"></datePicker>
        </b-form-group>
      </b-col>

      <!-- filter date to -->
      <b-col cols="2">
        <b-form-group id="input-to-date" label="Đến Ngày" label-for="to-date">
          <datePicker v-model="filter_to" :config="dpOptions"></datePicker>
        </b-form-group>
      </b-col>

      <!-- Filter game  -->
      <b-col cols="2">
        <b-form-group
          id="input-game-filter"
          label="Đài"
          label-for="game-filter"
        >
          <b-form-select
            id="game-filter"
            v-model="filter_product"
            :options="productList"
          >
            <template v-slot:first>
              <b-form-select-option :value="null">Tất cả</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col cols="2">
        <b-button
          block
          variant="success"
          class="search-btn"
          @click="handleSearch"
          >TÌM KIẾM</b-button
        >
      </b-col>
      <b-col cols="2">
        <b-button
          block
          variant="primary"
          class="search-btn"
          @click="handleExport"
          >XUẤT EXCEL</b-button
        >
      </b-col>
    </b-row>
    <b-table
      striped
      :fields="headers"
      :items="items"
      :busy="isBusy"
      :current-page="currentPage"
      responsive
      bordered
      small
      class="elevation-1 data-table text-center"
    >
      <template v-slot:cell(lottery_time)="item">{{
        formatDate(item.value, "DD-MM-YYYY")
      }}</template>
      <template v-slot:cell(product_name)="item">
        {{ item.value }}
      </template>
      <template v-slot:cell(stock_amount)="item">
        {{ item.value || 0 }}
      </template>
      <template v-slot:cell(remain_amount)="item">
        {{ item.value || 0 }}
      </template>
      <template v-slot:cell(sale_amount)="item"
        >{{ item.item.sale_amount }}
      </template>
      <template v-slot:cell(reward_amount)="item"
        >{{ formatPrice(item.item.reward_amount / item.item.sale_amount) }}
      </template>
    </b-table>
    <b-row>
      <b-col cols="3">
        Hiển thị {{ (currentPage - 1) * perPage + 1 }}-{{
          currentPage * perPage > rows ? rows : currentPage * perPage
        }}
        trong {{ rows }}.
      </b-col>
      <b-col style="display: flex; justify-content: flex-end">
        <b-form inline style="margin-right: 20px; margin-bottom: 1rem">
          <label class="mr-sm-2" for="per-page">Số dòng: </label>
          <b-form-select
            id="per-page"
            v-model="perPage"
            size="sm"
            :options="[5, 10, 15, 20]"
            @change="fetchData"
          ></b-form-select>
        </b-form>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
          align="right"
          v-on:input="fetchData"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import datePicker from "vue-bootstrap-datetimepicker";
import ApiService from "@/core/services/api.service.js";
import DateUtils from "@/utils/date.js";

// import axios from "axios";
export default {
  name: "Ticket",
  components: { datePicker },
  data() {
    let { firstDate, lastDate } = DateUtils.getDate(new Date(), 7);
    return {
      isLoading: true,
      isBusy: false,
      productList: [],
      headers: [
        { label: "Ngày Xổ", key: "lottery_time" },
        { label: "Đài", key: "product_name" },
        { label: "Bộ Số", key: "ticket_info" },
        { label: "Tổng Vé", key: "stock_amount" },
        { label: "Tồn Kho", key: "remain_amount" },
        { label: "Đã Bán", key: "sale_amount" },
        { label: "Tiền thưởng", key: "reward_amount" },
      ],
      // Modal data
      items: [],
      modalTitle: "",
      // Modal validate
      rows: 0,
      perPage: 10,
      currentPage: 1,
      dialog: false,
      dpOptions: {
        format: "MM/DD/YYYY",
        sideBySide: true,
      },
      timeout: null,
      filter_product: null,
      filter_from: firstDate,
      filter_to: lastDate,
      productName: {},
    };
  },
  created() {
    this.fetchData();
    this.getAllProduct();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Vé trúng thưởng" }]);
  },
  computed: {
    campaignId() {
      return this.$store.state.auth.campaignId;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    editedItem: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.editedItem = newVal;
      }
    },
    productList(val) {
      let name = {};
      val.forEach((item) => {
        name[item.value] = item.text;
      });
      this.productName = name;
    },
  },
  methods: {
    openGallery(id) {
      this.$refs[`lightbox_${id}`].showImage(0);
    },
    handleExport() {
      this.exportData(
        "/partners/exports/winning-tickets",
        this.getQueryParamsExport(),
      );
    },
    handleSearch() {
      if (this.timeOut) {
        clearTimeout(this.timeOut);
      }

      this.timeOut = setTimeout(() => {
        this.fetchData();
      }, 400);
    },
    getQueryParams() {
      let to = "";
      if (this.filter_to) {
        to = new Date(this.filter_to);
        to.setDate(to.getDate() + 1);
      }
      let returnObj = {
        limit: this.perPage,
        offset: this.currentPage,
        to,
        from: this.filter_from ? new Date(this.filter_from) : "",
      };
      if (this.isAdmin) {
        returnObj.username = this.username || "";
        returnObj.method = this.filter_method == null ? -1 : this.filter_method;
      }
      return returnObj;
    },
    getQueryParamsExport() {
      let to = "";
      if (this.filter_to) {
        to = new Date(this.filter_to);
        to.setDate(to.getDate() + 1);
      }
      let returnObj = {
        to,
        from: this.filter_from ? new Date(this.filter_from) : "",
      };
      if (this.isAdmin) {
        returnObj.username = this.username || "";
        returnObj.method = this.filter_method == null ? -1 : this.filter_method;
      }
      return returnObj;
    },
    fetchData() {
      ApiService.query("/storages/rewards", this.getQueryParams()).then(
        (response) => {
          this.items = response.data.data.ticketList;
          this.rows = response.data.data.total;
          this.isBusy = false;
        },
      );
    },
    getAllProduct() {
      ApiService.query("/products", {
        game_id: 8,
        limit: 99,
        offset: 0,
      }).then((response) => {
        this.productList = response?.data?.data?.productList?.map((item) => {
          return {
            text: item.name,
            value: item.id,
          };
        });
      });
    },
  },
};
</script>
